import PaymentProcessingModal from "../../modal/PaymentProcessingModal";
import TransactionStatusModal from "../../modal/TransactionStatusModal";

const CheckoutComCardFormView = ({
  t,
  loading,
  error,
  cardError,
  sdkLoading,
  cardReady,
  cardElementRef,
  showProcessingModal,
  setProcessingModal,
  showStatusModal,
  setShowStatusModal,
  transactionStatus,
  transactionId,
  hostedPageRedirect,
  checkoutConfDto,
}) => {
  return (
    <div className="checkout-card-container">
      {/* Card Component Container */}
      <div className="form-section">
        <div className="card-mount-area" style={{ position: "relative" }}>
          {sdkLoading && (
            <div className="sdk-loading-text">
              {t("paymentForms.card.loadingSDK")}
            </div>
          )}
          <div
            ref={cardElementRef}
            className={`card-element-wrapper ${
              !cardReady ? "loading" : ""
            } ${cardError ? "invalid" : ""}`}
          />
        </div>

        {cardError && (
          <div className="error-message">{cardError}</div>
        )}
      </div>

      {/* General Error */}
      {error && !cardError && (
        <div className="error-message">{error}</div>
      )}

      {/* Loading Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="spinner-large" />
          <div className="loading-text">
            {t("paymentForms.card.processing")}
          </div>
        </div>
      )}

      <PaymentProcessingModal
        show={showProcessingModal}
        setShow={setProcessingModal}
      />

      <TransactionStatusModal
        show={showStatusModal}
        setShow={setShowStatusModal}
        status={transactionStatus}
        transactionId={transactionId}
        hostedPageRedirect={hostedPageRedirect}
        fallbackRedirectUrl={checkoutConfDto?.checkoutRedirectUrl}
      />
    </div>
  );
};

export default CheckoutComCardFormView;
